import devfolio from "../../assets/sponsor-logo/devfolio.png";
import polygon from "../../assets/sponsor-logo/polygon.png";
import jj from "../../assets/sponsor-logo/jj.png";

export const gold = [
  {
    img: jj,
    link: "https://www.jobinandjismi.com/",
    width: "80%",
    height: "",
  },
  {
    img: devfolio,
    link: "https://devfolio.co",
    twitter: "https://twitter.com/devfolio",
    fb: "https://www.facebook.com/devfolio",
    insta: "https://www.instagram.com/devfolioco/",
    linkedin: "https://www.instagram.com/devfolioco/",
    width: "80%",
    height: "",
  },
  {
    img: polygon,
    link: "https://polygon.technology/",
    twitter: "https://twitter.com/0xPolygon",
    insta: "https://www.instagram.com/0xpolygon/",
    fb: "https://www.facebook.com/maticnetwork/",
    width: "80%",
    height: "",
  },
];
